// extracted by mini-css-extract-plugin
module.exports = {"AirCanadaNavigation":"ACNavigation_AirCanadaNavigation__2f7Sv","AirCanadaNavigationItem":"ACNavigation_AirCanadaNavigationItem__3WFL6"};